import SpeakersBlock from './SpeakersBlock';

export default SpeakersBlock;
